var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"white"}},[_c('Header'),_c('router-view',{staticStyle:{"width":"95%","margin":"auto"},attrs:{"name":"static"}}),_c('router-view',{attrs:{"name":"customStatic"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }